import {BaseComponent} from '@specials/gcs-engine';

import {HTMLElementId} from '@/constants';

export class SpaceshipMessageComponent extends BaseComponent {
  private tooltipTargetNode: HTMLDivElement;

  public onAddToWorld(): void {
    this.tooltipTargetNode = document.createElement('div');
    this.tooltipTargetNode.style.position = 'absolute';

    const container = document.getElementById(HTMLElementId.ClickerGamePageContainer);

    if (container) {
      container.appendChild(this.tooltipTargetNode);
    }
  }

  public setTooltipId(id: string): void {
    this.tooltipTargetNode.id = id;
  }

  public destroy(): void {
    this.tooltipTargetNode.remove();
  }

  public placeTooltip(x: number, y: number): void {
    this.tooltipTargetNode.style.left = x + 'px';
    this.tooltipTargetNode.style.top = y + 'px';
  }
}
